import { render } from "./DialogInvalidSection.vue?vue&type=template&id=27dacb67"
import script from "./DialogInvalidSection.vue?vue&type=script&lang=js"
export * from "./DialogInvalidSection.vue?vue&type=script&lang=js"
script.render = render

export default script